import { setupSlider } from "./swiper";

var lazyLoadInstance = new LazyLoad({
    elements_selector: ".lazy"
    // ... more custom settings?
});

/**
* This section initializes the mute button for showreel.
*
* @since 	1.0.0
* @author 	Mitchel Rijs
*/

const btn = document.getElementById('mute'),
      video = document.querySelector('video');

if (jQuery('#mute').length > 0) {
	btn.addEventListener('click', () => {
	  if (btn.value === 'unmuted') {
	    btn.value = 'muted';
	    btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36.38 32"><defs><style>.cls-1{fill:#fff;}</style></defs><title>unmute</title><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path class="cls-1" d="M20.35,32h-.17a3,3,0,0,1-1.63-.51l-.08-.07c-2-1.66-7.12-4.82-9.29-6.17l-.82-.52H2.93a2.91,2.91,0,0,1-2.06-.84,2.76,2.76,0,0,1-.87-2V10.38a2.8,2.8,0,0,1,.87-2A2.91,2.91,0,0,1,2.93,7.5H8.36l.49-.28A63.56,63.56,0,0,0,18.45.59l.1-.08A3,3,0,0,1,20.18,0h.23a2.5,2.5,0,0,1,2.24,2l0,.25,0,27.67a2.5,2.5,0,0,1-2.24,2Zm-.67-2.17a.91.91,0,0,0,.5.17h.06c.18,0,.34-.09.44-.43V2.43c-.1-.34-.26-.4-.44-.43h-.06a.94.94,0,0,0-.49.16A66.44,66.44,0,0,1,9.84,9l-.54.31-.24.23H2.93a.88.88,0,0,0-.66.27.8.8,0,0,0-.27.61V21.86a.77.77,0,0,0,.27.6.88.88,0,0,0,.66.27H9.06L9.3,23l.94.59C12.42,24.91,17.51,28.08,19.68,29.83Z"/><path class="cls-1" d="M35.38,21.5a1,1,0,0,1-.71-.29l-8-8a1,1,0,0,1,0-1.42,1,1,0,0,1,1.41,0l8,8a1,1,0,0,1-.7,1.71Z"/><path class="cls-1" d="M27.38,21.5a1,1,0,0,1-.71-1.71l8-8a1,1,0,0,1,1.41,0,1,1,0,0,1,0,1.42l-8,8A1,1,0,0,1,27.38,21.5Z"/></g></g></svg>';
	    video.muted = true;
	  } else {
	    btn.value = 'unmuted';
	    btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 32"><defs><style>.cls-1{fill:#fff;}</style></defs><title>mute</title><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path class="cls-1" d="M20.35,32h-.17a3,3,0,0,1-1.63-.51l-.08-.07c-2-1.66-7.12-4.82-9.29-6.17l-.82-.52H2.93a2.91,2.91,0,0,1-2.06-.84,2.76,2.76,0,0,1-.87-2V10.38a2.8,2.8,0,0,1,.87-2A2.91,2.91,0,0,1,2.93,7.5H8.36l.49-.28A63.56,63.56,0,0,0,18.45.59l.1-.08A3,3,0,0,1,20.18,0h.23a2.5,2.5,0,0,1,2.24,2l0,.25,0,27.67a2.5,2.5,0,0,1-2.24,2Zm-.67-2.17a.91.91,0,0,0,.5.17h.06c.18,0,.34-.09.44-.43V2.43c-.1-.34-.26-.4-.44-.43h-.06a.94.94,0,0,0-.49.16A66.44,66.44,0,0,1,9.84,9l-.54.31-.24.23H2.93a.88.88,0,0,0-.66.27.8.8,0,0,0-.27.61V21.86a.77.77,0,0,0,.27.6.88.88,0,0,0,.66.27H9.06L9.3,23l.94.59C12.42,24.91,17.51,28.08,19.68,29.83Z"/><path class="cls-1" d="M26.29,25.23a1,1,0,0,1,0-2A7.6,7.6,0,0,0,34,15.76a7.6,7.6,0,0,0-7.71-7.48,1,1,0,0,1,0-2A9.61,9.61,0,0,1,36,15.76,9.61,9.61,0,0,1,26.29,25.23Z"/><path class="cls-1" d="M26.29,21.32a1,1,0,0,1,0-2,3.57,3.57,0,1,0,0-7.13,1,1,0,0,1,0-2,5.57,5.57,0,1,1,0,11.13Z"/></g></g></svg>';
	    video.muted = false;
	  }
	});
}

/**
* This section initializes the video showreel loader.
*
* @since 	1.0.0
* @author 	Jelmer Holtes
*/	
jQuery('.video__player').on('playing canplay', function (event) {
	
	jQuery('.video__loader').addClass('video__initialised');
	
});

/**
* This section initializes the card animations.
*
* @since 	1.0.0
* @author 	Jelmer Holtes
*/	
jQuery(document).ready(function($){
	
	
	
	(function($) {
	
	  /**
	   * Copyright 2012, Digital Fusion
	   * Licensed under the MIT license.
	   * http://teamdf.com/jquery-plugins/license/
	   *
	   * @author Sam Sehnert
	   * @desc A small plugin that checks whether elements are within
	   *     the user visible viewport of a web browser.
	   *     only accounts for vertical position, not horizontal.
	   */
	
	  $.fn.visible = function(partial) {
	    
	      var $t            = $(this),
	          $w            = $(window),
	          viewTop       = $w.scrollTop(),
	          viewBottom    = viewTop + $w.height(),
	          _top          = $t.offset().top,
	          _bottom       = _top + $t.height(),
	          compareTop    = partial === true ? _bottom : _top,
	          compareBottom = partial === true ? _top : _bottom;
	    
	    return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
	
	  };
	    
	})(jQuery);
	
	var win = $(window);
	
	var allMods = $(".card");
	
	allMods.each(function(i, el) {
	  var el = $(el);
	  if (el.visible(true)) {
	    el.addClass("already-visible"); 
	  } 
	});
	
	win.scroll(function(event) {
	  
	  allMods.each(function(i, el) {
	    var el = $(el);
	    if (el.visible(true)) {
	      el.addClass("come-in"); 
	    } 
	  });
	  
	});
  
});

setupSlider();